import { SET_VIEW_REPORT_AS } from '../mutation-types'

export default {
  namespaced: true,
  state: () => ({
    viewReportAs: null,
  }),
  getters: {
    viewAsUserIdStringified: (state) => {
      return JSON.stringify({ viewAsUserId: state.viewReportAs?.userId ?? 0 })
    },
    viewAsUserIdJSON: (state) => {
      return { viewAsUserId: state.viewReportAs?.userId ?? 0 }
    },
  },
  mutations: {
    [SET_VIEW_REPORT_AS](state, payload) {
      state.viewReportAs = payload
    },
  },
  actions: {},
}
